<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Verified gross mass (VGM )</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div class="mt-2">
              <!-- <b-button
                size="sm"
                variant="outline-info"
                :class="visible ? null : 'collapsed'"
                :aria-expanded="visible ? 'true' : 'false'"
                aria-controls="collapse-4"
                @click="visible = !visible"
              >Hide Details</b-button> -->
              <!-- <b-collapse id="collapse-4" v-model="visible" class="mt-2">
                <b-card  class="HeaderMastBanner">
                  <md-layout gutter>
                    <md-layout md-flex="35">
                      <md-layout md-flex="100">
                        <b>
                          Client Name : {{ALLFclData[0].clientName}}
                          <br>
                        </b>
                        <b>
                          Assignment No. : {{ALLFclData[0].ffExportFclSeries}}
                          <br>
                        </b>
                          </md-layout>
                    </md-layout>
                           <md-layout md-flex="25">
                      <md-layout md-flex="100">
                         <b>
                          FF Activity : {{ALLFclData[0].containerInfo}}
                          <br>
                        </b>
                        <b>
                          Stuffing Type : {{ALLFclData[0].stuffingType}}
                          <br>
                        </b>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="40">
                      <md-layout md-flex="100">
                       
                        
                        <b>Shipping Line : {{ALLFclData[0].shippingLine}}</b>
                       
                      </md-layout>
                    </md-layout>
                  </md-layout>
                </b-card>
              </b-collapse> -->
            </div>

            <div v-if="containerNoList.length > 0 || vgmModel.ffVgmId != ''">
              <md-layout md-gutter>
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>Client Name *</label>
                    <b-form-input :formatter="capitalizeAll"
                      disabled
                      id="clientName"
                      name="clientName"
                      v-model="vgmModel.clientName"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>Client Registration / License No. *</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="clientRegistrationNo"
                      name="clientRegistrationNo"
                      v-model="vgmModel.clientRegistrationNo"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!vgmModel.clientRegistrationNo">{{
                    errorVgmList.clientRegistrationNo
                  }}</span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label
                      >Name and Registration of official of the client
                      authorized to sign document *</label
                    >
                    <b-form-input :formatter="capitalizeAll"
                      id="nameRegistrationOfficial"
                      name="nameRegistrationOfficial"
                      v-model="vgmModel.nameRegistrationOfficial"
                    ></b-form-input>
                  </md-layout>
                  <span
                    class="error"
                    v-if="!vgmModel.nameRegistrationOfficial"
                    >{{ errorVgmList.nameRegistrationOfficial }}</span
                  >
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label
                      >24*7 contact No. of authorized official of client
                      *</label
                    >
                    <b-form-input :formatter="capitalizeAll"
                      id="officialContactNo"
                      name="officialContactNo"
                      v-model="vgmModel.officialContactNo"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!vgmModel.officialContactNo">{{
                    errorVgmList.officialContactNo
                  }}</span>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="45">
                  <label for="containerNo" v-if="vgmModel.ffVgmId == ''"
                    >Container No *</label
                  >
                  <model-list-select
                    v-if="vgmModel.ffVgmId == ''"
                    :list="containerNoList"
                    v-model="vgmModel.ffExecutionContainerId"
                    option-value="uniqueContainerId"
                    option-text="containerNo"
                    placeholder="Select Container No"
                  ></model-list-select>
                  <md-layout md-flex="100" v-else>
                    <label for="containerNo">Container No *</label>
                    <b-form-input :formatter="capitalizeAll"
                      v-model="vgmModel.containerNo"
                      disabled
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!vgmModel.ffExecutionContainerId">{{
                    errorVgmList.ffExecutionContainerId
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="50">
                  <label for="containerTypeId"
                    >Container Size (TEU/FEU/Other)</label
                  >
                  <model-list-select
                    :list="ContainerTypeList"
                    v-model="vgmModel.containerTypeId"
                    option-value="containerTypeId"
                    option-text="containerType"
                    placeholder="Select Container Type/Size"
                    :isDisabled="true"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
              </md-layout>

              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label
                      >Verfiied Gross mass of container(Method-1/2) *</label
                    >
                    <model-list-select
                      :list="massWeightList"
                      v-model="vgmModel.verifiedConGrossMass"
                      option-value="mwV"
                      option-text="mwT"
                      placeholder="Select "
                    ></model-list-select>
                  </md-layout>
                  <span class="error" v-if="!vgmModel.verifiedConGrossMass">{{
                    errorVgmList.verifiedConGrossMass
                  }}</span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>VGM Weight *</label>
                    <b-form-input :formatter="capitalizeAll"
                      :disabled="
                        vgmModel.maxPermissibleWeight != '' ? false : true
                      "
                      type="number"
                      id="verifiedConGrossMass"
                      name="verifiedConGrossMass"
                      v-model="vgmModel.vgmWeight"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!vgmModel.vgmWeight">{{
                    errorVgmList.vgmWeight
                  }}</span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label
                      >Maximum permissible weight of container as per the CSC
                      plate *</label
                    >
                    <b-form-input :formatter="capitalizeAll"
                      type="number"
                      id="maxPermissibleWeight"
                      name="maxPermissibleWeight"
                      v-model="vgmModel.maxPermissibleWeight"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!vgmModel.maxPermissibleWeight">{{
                    errorVgmList.maxPermissibleWeight
                  }}</span>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="20">
                  <label>Date & time of Weighing *</label>
                  <date-picker
                    lang="en"
                    name="weighingDate"
                    id="weighingDate"
                    type="datetime"
                    format="YYYY-MM-DD hh:mm a"
                    :minute-step="1"
                    v-model="vgmModel.weighingDate"
                  ></date-picker>
                  <span class="error" v-if="!vgmModel.weighingDate">{{
                    errorVgmList.weighingDate
                  }}</span>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="75">
                  <md-layout md-flex="100">
                    <label>Weighing Slip No *</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="weighingSlipNo"
                      name="weighingSlipNo"
                      v-model="vgmModel.weighingSlipNo"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!vgmModel.weighingSlipNo">{{
                    errorVgmList.weighingSlipNo
                  }}</span>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>Weighbridge Registration No. *</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="weighbridgeRegNo"
                      name="weighbridgeRegNo"
                      v-model="vgmModel.weighbridgeRegNo"
                    ></b-form-input>
                  </md-layout>
                  <span class="error" v-if="!vgmModel.weighbridgeRegNo">{{
                    errorVgmList.weighbridgeRegNo
                  }}</span>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="gutr">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label>Weighbridge Address *</label>
                    <b-form-textarea :formatter="capitalizeAll"
                      id="weighbridgeAddress"
                      name="weighbridgeAddress"
                      v-model="vgmModel.weighbridgeAddress"
                    ></b-form-textarea>
                  </md-layout>
                  <span class="error" v-if="!vgmModel.weighbridgeAddress">{{
                    errorVgmList.weighbridgeAddress
                  }}</span>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="65">
                  <label for="autoCommodity">Commodity</label>
                  <model-list-select
                    :list="commodityList"
                    v-model="ffExoprtDetail.commodityId"
                    option-value="commodityId"
                    option-text="itemDescription"
                    placeholder="Select Commodity"
                    :isDisabled="true"
                  ></model-list-select>
                </md-layout>
                <md-layout md-flex="5"></md-layout>

                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label for="commodityType">Commodity Type</label>

                    <b-form-input :formatter="capitalizeAll"
                      id="commodityType"
                      name="commodityType"
                      disabled
                      v-model="ffExoprtDetail.commodityType"
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="labelMargtop">
                <md-layout md-flex="100">
                  <md-layout md-flex="100">
                    <label for="itemDescription">Item Description</label>

                    <b-form-textarea :formatter="capitalizeAll"
                      id="itemDescription"
                      name="itemDescription"
                      disabled
                      v-model="ffExoprtDetail.itemDescription"
                    ></b-form-textarea>
                  </md-layout>
                </md-layout>
              </md-layout>
              <md-layout
                md-gutter
                class="gutr"
                v-if="ffExoprtDetail.commodityType == 'Hazardous'"
              >
                <md-layout md-flex="35">
                  <md-layout md-flex="100">
                    <label>IMDG Class</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="IMDGClass"
                      name="IMDGClass"
                      v-model="ffExoprtDetail.IMDGClass"
                      disabled
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="25">
                  <md-layout md-flex="100">
                    <label>UN Number</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="UNNumber"
                      name="UNNumber"
                      v-model="ffExoprtDetail.UNNumber"
                      disabled
                    ></b-form-input>
                  </md-layout>
                </md-layout>
                <md-layout md-flex="5"></md-layout>
                <md-layout md-flex="30">
                  <md-layout md-flex="100">
                    <label>Packing Code</label>
                    <b-form-input :formatter="capitalizeAll"
                      id="packingCode"
                      name="packingCode"
                      v-model="ffExoprtDetail.packingCode"
                      disabled
                    ></b-form-input>
                  </md-layout>
                </md-layout>
              </md-layout>

              <md-layout md-gutter class="gutr">
                <md-layout md-flex="30">
                  <b-button
                    class="mt-3"
                    variant="primary"
                    @click="addVGM"
                    id="addButtonLoader1"
                    >{{ vgmModel.ffVgmId != "" ? "Update" : "Save" }} &
                    Submit</b-button
                  >
                  <md-spinner
                    md-indeterminate
                    id="loader1"
                    style="display: none"
                  ></md-spinner>
                </md-layout>
              </md-layout>
            </div>

            <div class="mt-3" v-if="vgmArrayList.length > 0">
              <div>
                <h5>
                  <b-badge>VGM Details</b-badge>
                </h5>
              </div>

              <!-- /.box-header -->
              <div class="box-body">
                <table id="poTablefdfdf" class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th>Client Name</th>
                      <th>ContainerNo</th>
                      <th>Container Type</th>

                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in vgmArrayList" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.clientName }}</td>
                      <td>{{ item.containerNo }}</td>
                      <td>{{ item.containerType }}</td>

                      <td>
                        <b-button
                          variant="outline-info"
                          size="sm"
                          @click="viewEdit(item)"
                          >Edit</b-button
                        >

                        <b-button
                          variant="outline-info"
                          size="sm"
                          @click="Print(item.uploadVgm)"
                          >PDF</b-button
                        >
                        <b-button
                          variant="outline-info"
                          size="sm"
                          @click="downloadWord(item.ffVgmId)"
                          >WORD FILE</b-button
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.box-body -->
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPopMaxPer"
      @close="clearPermisibleWgt"
    ></md-dialog-alert>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop6"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch("setCurrentRoute", "/freightForward/vgmDetail");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      visible: true,
      docURL: URL_BASE_DOC,
      isLoading: false,
      containerNoName: [],
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      excelUpload: "",
      massWeightList: [
        {
          mwT: "Method-1",
          mwV: "1",
        },
        {
          mwT: "Method-2",
          mwV: "2",
        },
      ],
      vgmModel: {
        ffVgmId: "",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
        clientName: "",
        vgmWeight: "",
        clientId: "",
        containerType: "",
        sizeTeu: "",
        ffExecutionContainerId: "",
        clientRegistrationNo: "",
        officialContactNo: "",
        nameRegistrationOfficial: "",
        containerNo: "",
        containerTypeId: "",
        maxPermissibleWeight: "",
        verifiedConGrossMass: "",
        weighingDate: "",
        weighingSlipNo: "",
        weighbridgeRegNo: "",
        weighbridgeAddress: "",
        commodityId: "",
      },

      errorVgmList: {
        clientRegistrationNo: "",
        officialContactNo: "",
        nameRegistrationOfficial: "",
        maxPermissibleWeight: "",
        verifiedConGrossMass: "",
        weighingDate: "",
        weighingSlipNo: "",
        weighbridgeRegNo: "",
        weighbridgeAddress: "",
        ffExecutionContainerId: "",
        vgmWeight: "",
      },
      arrayErrorVgm: [
        "Enter regristration No",
        "Enter Contact no",
        "Enter name registration",
        "Enter max permissible weight",
        "Enter verified gross mass",
        "Select weighing Date",
        "Enter weighing slip no",
        "Enter weighbrigde registration No",
        "Enter weighbridge address",
        "Select Container No",
        "Enter VGM Weight",
      ],

      removeVmodel: {
        weighingSlipNo: "",

        containerNo: "",
        containerTypeId: "",
        ffExecutionContainerId: "",
        ffVgmId: "",
      },
      vgmArrayList: [],
      CommodityAll: {},
      getCommodityData: ["zim"],
      ALLFclData: ["zim"],

      getContainerTypeData: ["zim"],
      validate: true,
      portCodeError: "",
      deleteId: "",
      ffExoprtDetail: {
        commodityId: "",
        IMDGClass: "",
        UNNumber: "",
        packingCode: "",
        commodityType: "",
        itemDescription: "",
      },
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date)
    },
  },
  watch: {
    vgmModel: {
      handler: function (newVal, oldVal) {
        if (newVal.ffExecutionContainerId != "") {
          let arrayNewContainer = this.containerNoName.filter((x) => {
            return x.uniqueContainerId == newVal.ffExecutionContainerId;
          });
          if (arrayNewContainer.length > 0) {
            this.vgmModel.containerTypeId =
              arrayNewContainer[0].containerTypeId;
            this.vgmModel.containerType = arrayNewContainer[0].containerType;
          }
        }
        if (newVal.maxPermissibleWeight != "") {
          let vgmweight = parseFloat(newVal.vgmWeight);
          let maxPermis = parseFloat(newVal.maxPermissibleWeight);
          if (vgmweight > maxPermis) {
            this.alert.content =
              " VGM Weight Weight must be less than or equal to Max Permissible Weight ";
            this.$refs["addPopMaxPer"].open();
          }
        }
      },
      deep: true,
    },
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
  },

  computed: {
    containerNoList() {
      return this.containerNoName;
    },
    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    commodityList() {
      return this.getCommodityData;
    },
  },

  methods: {
    clearPermisibleWgt() {
      this.vgmModel.vgmWeight = "";
    },
    downloadWord(id) {
      window.location =
        // "http://164.52.198.182/pridelApiNew/Freight/wordVGM.php?id=" +
        `${this.URL_BASE}/Api_FFSeaExport/wordVGM.php?id=` +
        id +
        "&tableId=ffVgmId" +
        "&tableName=ff_vgm_detail";
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    Print(item) {
      this.openSignedDocument(`ASSIGNMENT_UPLOADS/${this.ALLFclData[0].ffExportFclSeries.replaceAll("/", "_")}/${item}`);
    },
    viewEdit(item) {
      let arrayFilter = this.vgmArrayList.filter((x) => {
        return x.ffVgmId == item.ffVgmId;
      });

      Object.keys(this.vgmModel).map((x) => {
        this.vgmModel[x] = arrayFilter[0][x] || "";
      });
    },
    getData() {
      this.doLoading();
      let type_Size = {
        itemCode: "itemCode",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/fetchToVgm_NewV3.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.getContainerTypeData = data.containerMaster;
            this.getCommodityData = data.CommodityData;

            if (data.containerDetail.length > 0) {
              this.containerNoName = data.containerDetail;
            } else {
              this.containerNoName = [];
            }
            if (data.FullfclDetails.length > 0) {
              this.ALLFclData = data.FullfclDetails;
              Object.keys(this.ffExoprtDetail).map((x) => {
                this.ffExoprtDetail[x] = data.FullfclDetails[0][x] || "";
              });

              let item = this.getCommodityData.filter((x) => {
                return x.commodityId == data.FullfclDetails[0]["commodityId"];
              });

              if (item.length > 0) {
                this.ffExoprtDetail.commodityType = item[0].commodityType;
                this.ffExoprtDetail.itemDescription = item[0].itemDescription;
              }
              this.vgmModel.clientName = data.FullfclDetails[0].clientName;
              this.vgmModel.clientId = data.FullfclDetails[0].clientId;
            }

            if (data.vgmTableDetails.length > 0) {
              this.vgmArrayList = data.vgmTableDetails;

              Object.keys(this.vgmModel).map((x) => {
                this.vgmModel[x] = data.vgmTableDetails[0][x] || "";
              });

              Object.keys(this.removeVmodel).map((x) => {
                this.vgmModel[x] = "";
              });
            }
            this.doLoadingClose();
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    CommodityCallback(item) {
      this.ffExoprtDetail.commodityId = item.commodityId;
      this.ffExoprtDetail.commodityType = item.commodityType;
      this.ffExoprtDetail.itemDescription = item.itemDescription;
    },
    // JqueryFun() {
    //   return $(function() {
    //     return $("#portLocationNew").DataTable();
    //   });
    // },

    previousSalesView() {
      window.history.go(-1);
      // if (this.ALLFclData[0]["stuffingType"] == "factoryStuffing") {
      //   this.$router.push({
      //     path: "/freightForward/ffExecution"
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/freightForward/ffexecutionWareHouse"
      //   });
      // }
    },

    validateAddVehicleSizeForm() {
      let validate_new = true;
      if (this.vgmModel.portName == "") {
        $("#portName").focus();
        this.portNameError = "Enter Port Name";
        validate_new = false;
      }

      if (this.vgmModel.portCode == "") {
        $("#portCode").focus();
        this.portCodeError = "Enter Port Code ";
        validate_new = false;
      }

      if (this.vgmModel.portLocation == "") {
        $("#portLocation").focus();
        this.portLocationError = "Enter Port Location ";
        validate_new = false;
      }
      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    validateVGM() {
      let validate_new = true;
      Object.keys(this.errorVgmList).map((x, index) => {
        if (this.vgmModel[x] == "") {
          this.errorVgmList[x] = this.arrayErrorVgm[index];
          validate_new = false;
        }
      });
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },

    addVGM() {
      this.vgmModel["salesSeries"] =
        this.ALLFclData[0].ffExportFclSeries.replaceAll("/", "_");
      this.vgmModel["allModuleId"] = this.ALLFclData[0].allModuleId;
      if (this.containerNoName.length > 0 && this.vgmModel.ffVgmId == "") {
        let arrayNew = this.containerNoName.filter((x) => {
          return x.uniqueContainerId == this.vgmModel.ffExecutionContainerId;
        });

        if (arrayNew.length > 0) {
          this.vgmModel.containerNo = arrayNew[0].containerNo;
        }
      }

      this.validateVGM();
      if (this.validate != false) {
        let newData = {
          vgmModel: this.vgmModel,
          ffExoprtDetail: this.ffExoprtDetail,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addVgm.php`,
          data: JSON.stringify(newData),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            if (result.data.Id != "" && result.data.Id != undefined) {
              if (this.vgmModel.ffVgmId != "") {
                this.alert.content = "Data updated Successfully";
              } else {
                this.alert.content = "Data Added Successfully";
              }

              Object.keys(this.removeVmodel).map((x) => {
                this.vgmModel[x] = "";
              });
              this.getData();

              this.$refs["addPop"].open();
            }
          })
          .catch((error) => {});
      }
    },
    deleteData(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this item?";
      this.$refs["addPop6"].open();
    },

    onClose(type) {},
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// newVgmDetail.vue?0777006a